module.exports = __webpack_public_path__ + "img/banner-tc5.98ea3982.jpg";